export const saeByIc = [
    { "ic2025": 1, "text": "Mixed Associate Large", "yLine": "1.25" },
    { "ic2025": 2, "text": "Mixed Associate Medium", "yLine": "1.25" },
    { "ic2025": 3, "text": "Mixed Associate Small", "yLine": "1.25" },
    { "ic2025": 4, "text": "Mixed Associate/Baccalaureate", "yLine": "1.25" },
    { "ic2025": 5, "text": "Mixed Baccalaureate", "yLine": "1.5" },
    { "ic2025": 6, "text": "Mixed Undergraduate/Graduate-Doctorate Large", "yLine": "1.5" },
    { "ic2025": 7, "text": "Mixed Undergraduate/Graduate-Doctorate Medium", "yLine": "1.5" },
    { "ic2025": 8, "text": "Mixed Undergraduate/Graduate-Doctorate Small", "yLine": "1.5" },
    { "ic2025": 9, "text": "Mixed Undergraduate/Graduate-Master's Large/Medium", "yLine": "1.5" },
    { "ic2025": 10, "text": "Mixed Undergraduate/Graduate-Master's Small", "yLine": "1.5" },
    { "ic2025": 11, "text": "Professions-focused Associate Large/Medium", "yLine": "1.25" },
    { "ic2025": 12, "text": "Professions-focused Associate Small", "yLine": "1.25" },
    { "ic2025": 13, "text": "Professions-focused Associate/Baccalaureate", "yLine": "1.25" },
    { "ic2025": 14, "text": "Professions-focused Baccalaureate Medium", "yLine": "1.5" },
    { "ic2025": 15, "text": "Professions-focused Baccalaureate Small", "yLine": "1.5" },
    { "ic2025": 16, "text": "Professions-focused Undergraduate/Graduate-Doctorate Large", "yLine": "1.5" },
    { "ic2025": 17, "text": "Professions-focused Undergraduate/Graduate-Doctorate Medium", "yLine": "1.5" },
    { "ic2025": 18, "text": "Professions-focused Undergraduate/Graduate-Doctorate Small", "yLine": "1.5" },
    { "ic2025": 19, "text": "Professions-focused Undergraduate/Graduate-Master's Large/Medium", "yLine": "1.5" },
    { "ic2025": 20, "text": "Professions-focused Undergraduate/Graduate-Master's Small", "yLine": "1.5" },
    { "ic2025": 21, "text": "Special Focus: Applied and Career Studies", "yLine": "1.25" },
    { "ic2025": 22, "text": "Special Focus: Arts and Sciences", "yLine": "1.5" },
    { "ic2025": 23, "text": "Special Focus: Arts, Music, and Design", "yLine": "1.25" },
    { "ic2025": 24, "text": "Special Focus: Business", "yLine": "1.25" },
    { "ic2025": 25, "text": "Special Focus: Graduate Studies", "yLine": "null" },
    { "ic2025": 26, "text": "Special Focus: Law", "yLine": "null" },
    { "ic2025": 27, "text": "Special Focus: Medical Schools and Centers", "yLine": "null" },
    { "ic2025": 28, "text": "Special Focus: Nursing", "yLine": "1.25" },
    { "ic2025": 29, "text": "Special Focus: Other Health Professions", "yLine": "1.25" },
    { "ic2025": 30, "text": "Special Focus: Technology, Engineering, and Sciences", "yLine": "1.5" },
    { "ic2025": 31, "text": "Special Focus: Theological Studies", "yLine": "null" }
];

export const saeByIcQuads = {
    //Lower Access, Lower Earnings
    1: 5,
    // Higher Access, Lower Earnings
    2: 6,
    // Lower Access, Medium Earnings
    3: 3,
    // Higher Access, Medium Earnings
    4: 4,
    // Lower Access, Higher Earnings
    5: 1,
    // Opportunity Colleges and Universities - Higher Access, Higher Earnings
    6: 2
}


export function preProcess(data, highlightUnitID = null, dotSize = 10) {
    let output = [];

    // 4/12: update to do a col layout to reduce file size
    let keys = [
        "unitid",
        "name",
        "stabbr",
        "control",
        "size",
        "hbcu",
        "pbi",
        "annhsi",
        "tribal",
        "aanapisi",
        "hsi",
        "nasnti",
        "landgrnt",
        "womens",
        "ic2025",
        "saec2025",
        "research2025",
        "access_ratio",
        "earnings_ratio",
        "sae_2025_earnings",
        "pell_2023",
        "sae_urm_2023",

    ];

    for (let i = 0; i < data.length; i++) {
        let entry = {};
        keys.forEach((key, j) => entry[key] = data[i][j]);
        if (!entry.access_ratio || !entry.earnings_ratio) {
            continue;
        }
        if (entry.access_ratio > 3) {
            entry.x = 3;
        }
        else {
            entry.x = entry.access_ratio;
        }
        if (entry.earnings_ratio > 3) {
            entry.y = 3;
        }
        else {
            entry.y = entry.earnings_ratio;
        }
        if (highlightUnitID && highlightUnitID == entry.unitid) {
            entry.r = dotSize;
        }
        output.push(entry);
    }
    return output;
}



